<template>
  <div id="app">
    <el-container>
      <el-header class="app-header">
        <div class="header-inner">
          <!-- Logo -->
          <div class="logo" @click="$router.push('/')">
            <img src="https://lilishop.oss-cn-beijing.aliyuncs.com/logo/tgr-logo.svg" alt="Logo" />
          </div>

          <!-- PC端菜单 (仅大屏显示) -->
          <el-menu
              :default-active="defaultActive"
              class="pc-menu el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
              :router="router"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/goin">走进tgr</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/product">企业印象</el-menu-item>
            <el-menu-item index="">
              <a href="http://www.tgr88.com/" target="_blank">特格尔巴巴</a>
            </el-menu-item>
            <el-menu-item index="">
              <a href="https://www.tgr39.com/" target="_blank">特格尔快药</a>
            </el-menu-item>
          </el-menu>

          <!-- 移动端汉堡按钮 (仅小屏显示) -->
          <div class="mobile-hamburger" @click.stop="toggleMobileMenu">
            <i :class="isMobileMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
          </div>
        </div>

        <!-- 移动端原生菜单 (绝对定位，覆盖全屏) -->
        <transition name="slide-down">
          <div v-if="isMobileMenuOpen" class="mobile-native-menu">
            <ul>
              <li @click="handleMobileNav('/')">首页</li>
              <li @click="handleMobileNav('/goin')">走进tgr</li>
              <li @click="handleMobileNav('/news')">新闻资讯</li>
              <li @click="handleMobileNav('/product')">企业印象</li>
              <li @click="openExternal('http://www.tgr88.com/')">特格尔巴巴</li>
              <li @click="openExternal('https://www.tgr39.com/')">特格尔快药</li>
            </ul>
          </div>
        </transition>
      </el-header>

      <!-- Main Content -->
      <el-main>
        <router-view/>
      </el-main>

      <!-- Footer -->
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li class="content-nav-li" @click="goLink('/goin')">
              <p>走进tgr</p>
              <span>公司简介</span>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
            </li>
            <li class="content-nav-li" @click="goLink('/news')">
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>热门推荐</span>
            </li>
            <li class="content-nav-li" @click="goLink('/product')">
              <p>企业印象</p>
              <span>介绍视频</span>
            </li>
            <li class="footer-links">
              <p>平台网站</p>
              <span><a href="https://www.tgr39.com/" target="_blank">特格尔快药</a></span>
              <span><a href="http://mall.tgr88.com/" target="_blank">特格尔巴巴</a></span>
              <span><a href="https://store.tgrys.com/" target="_blank">特格尔互联网医院</a></span>
              <span><a href="https://home.tgr39.com/admin/" target="_blank">官网管理</a></span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：it_admin@tgr39.com</span>
              <span>电话：0731-88677088</span>
            </li>
          </ul>
          <div class="footer-qrcodes">
            <img :src="tgrkyWxCode" alt="快药二维码"/>
            <img :src="tgrysWxCode" alt="医生二维码"/>
          </div>
        </div>
        <div class="copyright">
          <div>
            <a href="https://beian.miit.gov.cn/" target="_blank"> 湘ICP备14008635号-1 </a>
            <span class="mal20">Copyright © {{ currentYear }} TGR</span>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      currentYear: new Date().getFullYear(),
      logoUrl: "",
      tgrkyWxCode: "",
      tgrysWxCode: "",
      isMobileMenuOpen: false, // 控制移动端菜单开关
    };
  },
  mounted() {
    this.getStaticData();
    const lastPath = localStorage.getItem('lastPath');
    if (lastPath) {
      this.defaultActive = lastPath;
      this.isShow = lastPath !== '/';
    }

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 切换菜单显示
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },

    // 处理移动端内部路由跳转
    handleMobileNav(path) {
      this.isMobileMenuOpen = false; // 先关闭菜单
      this.handleSelect(path);       // 执行原有逻辑（保存状态等）
      this.$router.push({ path: path }); // 强制跳转
    },

    // 处理外部链接
    openExternal(url) {
      this.isMobileMenuOpen = false;
      window.open(url, '_blank');
    },

    handleResize() {
      if (window.innerWidth > 768) {
        this.isMobileMenuOpen = false;
      }
    },

    // 原有逻辑保持不变
    handleSelect(key) {
      localStorage.setItem('lastPath', key);
      if (key == '/') {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
      window.console.log(this.isShow);
    },

    goLink(url) {
      if (this.defaultActive == url) {
        return;
      }
      this.defaultActive = url;
      this.$router.push({path: url});
    },

    getStaticData() {
      this.$http
          .get("api-homepage/home/homepage/filePath?fileName=&fileType=")
          .then(res => {
            let resData = res.data.data;
            resData.forEach(item => {
              if (item.fileType == "logo图") this.logoUrl = item.filePath;
              if (item.fileType == "底部二维码1") this.tgrkyWxCode = item.filePath;
              if (item.fileType == "底部二维码2") this.tgrysWxCode = item.filePath;
              if (item.fileType == "首页大图") this.$appData.shouyeBanner = item.filePath;
              if (item.fileType == "banner图") this.$appData.bannerUrl = item.filePath;
              if (item.fileType == "公司简介右图") this.$appData.aboutusUrl = item.filePath;
              if (item.fileType == "企业印象") this.$appData.vedioUrl = item.filePath;
              if (item.fileType == "特格尔快药iPhone版") this.$appData.tgrkyApple = item.filePath;
              if (item.fileType == "特格尔快药Andrio版") this.$appData.tgrkyAndriod = item.filePath;
              if (item.fileType == "特格尔医生iPhone版") this.$appData.tgrysApple = item.filePath;
              if (item.fileType == "特格尔医生Andrio版") this.$appData.tgrysAndriod = item.filePath;
            });
          })
          .catch(err => {
            console.error("获取静态资源失败", err);
          });
    }
  }
};
</script>

<style lang="scss">
/* 全局重置 */
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
}

/* Header 样式 */
.el-header {
  padding: 0;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  position: relative; /* 关键：作为绝对定位子元素的参考 */
}

.header-inner {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 60px;
}

.logo {
  width: 100px;
  padding: 10px;
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

/* PC端菜单样式 */
.pc-menu {
  border-bottom: none;
  background: transparent;

  .el-menu-item {
    a {
      &:hover {
        color: #48a83c;
      }
    }
  }
}

/* 移动端汉堡按钮 (默认隐藏) */
.mobile-hamburger {
  display: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  padding: 10px;
  z-index: 1002;
  background: #fff;
  border-radius: 4px;
}

/* 移动端原生菜单 (关键修复部分) */
.mobile-native-menu {
  position: absolute;
  top: 100%; /* 紧贴 header 底部 */
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  z-index: 9999; /* 极高优先级，确保不被遮挡 */
  border-top: 1px solid #eee;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 15px 20px;
      border-bottom: 1px solid #f0f0f0;
      color: #333;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.2s;

      &:active {
        background-color: #f5f5f5;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

/* 动画效果 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}


/* Main 区域 */
.el-main {
  padding: 0 !important;
  flex: 1;
}

/* Footer 样式 */
.footer {
  width: 100%;
  overflow: hidden;
  background-color: #48a83c;
  color: #fff;

  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .content-nav {
      display: flex;
      justify-content: space-around;
      flex: 1;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        align-items: flex-start;
        list-style: none;

        p {
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
          padding-bottom: 15px;
          margin-bottom: 5px;
          border-bottom: 2px solid rgba(255,255,255,0.3);
        }

        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 6px 0;
          font-size: 14px;
          cursor: pointer;
          transition: opacity 0.3s;

          &:hover {
            opacity: 0.8;
          }

          a {
            color: #f7f7f7;
            text-decoration: none;
          }
        }
      }

      .content-nav-li {
        cursor: pointer;
      }
    }

    .footer-qrcodes {
      display: flex;
      gap: 20px;

      img {
        width: 120px;
        height: 120px;
        background: #fff;
        padding: 5px;
        border-radius: 4px;
      }
    }
  }

  .copyright {
    background: #3d8f33;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    color: #f5f5f5;
    font-size: 12px;

    span {
      color: #fff;
      line-height: 20px;
    }

    a {
      color: #cce4ff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .mal20 {
      margin-left: 20px;
    }
  }
}

/* ================= 移动端适配 (Max Width 768px) ================= */
@media screen and (max-width: 768px) {

  /* Header 适配 */
  .header-inner {
    width: 100%;
    padding: 0 15px;
  }

  .logo {
    width: 90px;
    padding: 5px;
  }

  .pc-menu {
    display: none;
  }

  .mobile-hamburger {
    display: block;
  }

  /* Footer 适配 */
  .footer-content {
    width: 100%;
    padding: 20px 15px;
    flex-direction: column;

    .content-nav {
      flex-direction: column;
      width: 100%;

      li {
        width: 100%;
        padding: 15px 0;
        border-bottom: 1px solid rgba(255,255,255,0.1);

        p {
          font-size: 16px;
          margin-bottom: 10px;
        }

        span {
          font-size: 13px;
        }
      }
    }

    .footer-qrcodes {
      margin-top: 20px;
      justify-content: center;
      width: 100%;

      img {
        width: 100px;
        height: 100px;
      }
    }
  }

  .copyright {
    flex-direction: column;
    text-align: center;
    padding: 10px;

    .mal20 {
      margin-left: 0;
      margin-top: 5px;
      display: block;
    }
  }
}
</style>
